/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_Toast_ErrorInputs */

const vi_customer_refund_toast_error = /** @type {(inputs: Customer_Refund_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lập được phiếu hoàn tiền`)
};

/**

* @param {Customer_Refund_Toast_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_toast_error = /** @type {((inputs?: Customer_Refund_Toast_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_Toast_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_toast_error(inputs)
});